import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('usersGrid');

    return {
        CREATED_AT: t('createdAt'),
        LAST_ACTIVITY: t('lastActivity'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_MORE_USERS: t('noMoreUsers'),
        NO_USERS: t('noUsers'),
        ROLES: t('roles'),
        STATUS: t('status')
    };
};

export default useTranslation;
